import { RigaDistinta } from './RigaDistinta';
import { RigaDistintaPerComunicazioneVariazione } from './VariazioneDaComunicare';

export enum StatoVariazioneRigaDistinta {
    RigaModificataDalFornitore = 1,
    RigaEliminataDalFornitore,
    RigaAggiuntaDalFornitore,
    RigaModificataDaBC,
    RigaEliminataDaBC,
    RigaAggiuntaDaBC,
}

export interface ComunicazioneVariazioneRigaDistinta {
    idFornitore: string,
    idDistinta: string,
    idRigaDistinta: string,
    idUtente: string,
    quantitaPerTaglia: number[],
    statoVariazione: StatoVariazioneRigaDistinta,
    nuovaRigaDistinta?: RigaDistintaPerComunicazioneVariazione
}
